"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _ImagePreview = _interopRequireDefault(require("../ImagePreview")),
    _getDarkModeImageProps = _interopRequireDefault(require("../../utils/getDarkModeImageProps")),
    _fileTypeIconMap = _interopRequireDefault(require("../../../../common/constants/fileTypeIconMap"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function getIcon(type, assetMissing, asset) {
  return asset ? assetMissing ? "faq" : _fileTypeIconMap["default"][type] || "document" : "corrupt";
}

function getSubtitle(asset, assetMissing) {
  return asset ? assetMissing ? "Missing" : "" : "Deleted";
}

function OtherPreview(_ref) {
  var asset = _ref.asset,
      type = _ref.type,
      hideFileTypeIcon = _ref.hideFileTypeIcon,
      darkMode = _ref.darkMode,
      assetMissing = _ref.assetMissing,
      uploadingAsset = _objectSpread({}, asset, {
    assetFiles: {
      ORIGINAL: {
        type: "ORIGINAL",
        sourceUrl: "",
        assetFileId: ""
      }
    }
  }),
      assetUploaded = asset && (void 0 === asset.loadedPercent || 100 === asset.loadedPercent),
      colourMap = (0, _getDarkModeImageProps["default"])({
    darkMode: darkMode
  }),
      assetInErrorState = !asset || assetMissing;

  return _react["default"].createElement(_ImagePreview["default"], {
    asset: uploadingAsset,
    hideFileTypeIcon: hideFileTypeIcon || !asset,
    imageProps: {
      defaultImageIcon: getIcon(type, assetMissing, asset),
      defaultIconBackground: assetUploaded || assetInErrorState ? colourMap.background : void 0,
      defaultIconColour: assetUploaded || assetInErrorState ? colourMap.icon : void 0,
      defaultIconSize: assetInErrorState ? 40 : void 0,
      defaultIconSubtitle: getSubtitle(asset, assetMissing)
    },
    type: type
  });
}

var _default = (0, _react.memo)(OtherPreview);

exports["default"] = _default;